<template>
  <div>
    <v-select
      v-model="selectedDateFilter"
      :items="dateFilters"
      @change="handleDateChange"
      v-bind="selectProps"
    >
      <template v-if="showDatePicker" #selection>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="customDateRange"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="flex">
              <v-icon>mdi-calendar</v-icon>
              <span>{{ dateRangeText }}</span>
            </div>
          </template>
          <v-date-picker v-model="customDateRange" range no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancelar
            </v-btn>
            <v-btn text color="primary" @click="handleCustomDate">
              Aceptar
            </v-btn>
          </v-date-picker>
        </v-menu>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    default: {
      type: String,
      default: "Todas"
    },
    options: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Selecciona un filtro de fecha"
    },
    variant: {
      type: String,
      default: "outlined"
    }
  },
  data() {
    return {
      selectedDateFilter: this.default,
      menu: false,
      dateRangeText: "",
      customDateRange: [],
      dateFilters: this.options.length
        ? this.options
        : [
            "Todas",
            "Ayer",
            "Hoy",
            "Últimos 7 días",
            "Últimos 30 días",
            "Mes pasado",
            "Este mes",
            "Año actual",
            "Personalizado"
          ]
    };
  },
  mounted() {
    this.handleDateChange();
  },
  computed: {
    showDatePicker() {
      return this.selectedDateFilter === "Personalizado";
    },
    selectProps() {
      return {
        label: this.label,
        [this.variant]: true,
        dense: this.dense,
        hideDetails: true
      };
    }
  },
  methods: {
    handleDateChange() {
      let startDate = new Date();
      let endDate = new Date();

      switch (this.selectedDateFilter) {
        case "Ayer":
          startDate.setDate(startDate.getDate() - 1);
          endDate.setDate(endDate.getDate() - 1);
          break;
        case "Hoy":
          // Las fechas ya están configuradas para hoy
          break;
        case "Últimos 7 días":
          startDate.setDate(startDate.getDate() - 7);
          break;
        case "Últimos 30 días":
          startDate.setDate(startDate.getDate() - 30);
          break;
        case "Mes pasado":
          startDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth() - 1,
            1
          );
          endDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
          break;
        case "Este mes":
          startDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            1
          );
          break;
        case "Año actual":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
        case "Personalizado":
          //this.menu = true;
          break;
        case "Todas":
        default:
          startDate = "";
          endDate = "";
      }

      this.applyDateRange(startDate, endDate);
    },
    handleCustomDate() {
      this.menu = false;
      if (this.customDateRange.length === 2) {
        const [start, end] = this.customDateRange;
        this.applyDateRange(new Date(start), new Date(end));
      }
    },
    applyDateRange(start, end) {
      if (start) {
        // Ajustar para la zona horaria local
        start = this.adjustDateForTimezone(start);
        end = this.adjustDateForTimezone(end);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        this.dateRangeText = `${this.formatDate(start)} - ${this.formatDate(
          end
        )}`;
      }
      // emitir el evento para que el componente padre pueda manejar el rango de fechas
      this.$emit("input", { start, end });
    },
    formatDate(date, format = "short") {
      if (format === "short") {
        return this.formatShortDate(date);
      }
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const monthName = date.toLocaleString("es", { month: "short" });
      const month = monthName.charAt(0).toUpperCase() + monthName.slice(1);
      const year = date.getFullYear();
      const hours = date
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      return `${month} ${day}, ${year} ${hours}:${minutes}`;
    },

    formatShortDate(date) {
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    adjustDateForTimezone(date) {
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() + userTimezoneOffset);
    },
    resetDateRange() {
      this.selectedDateFilter = this.default;
      this.dateRangeText = "";
      this.menu = false;
      this.customDateRange = [];
      this.handleDateChange();
    }
  }
};
</script>
